import React from 'react';
import { Grid, Typography } from '@mui/material';
import LegalPerson from './legalPerson/legalPerson';
import { useStyles } from 'components/Styles';

export default function UserInfo(props) {
  const { formik } = props;
  const classes = useStyles();

  return (
    <>
      <Typography style={{
        fontWeight: '700', fontSize: '25px', textAlign: 'left', marginTop: '0rem', position: 'absolute',
      }}
      >
        Vamos criar uma fazenda
      </Typography>
      <Typography style={{
        fontSize: '21px', textAlign: 'left', marginTop: '4rem', position: 'absolute',
      }}
      >
        Insira as informações da sua fazenda.
      </Typography>
      <LegalPerson formik={formik} />
    </>
  );
}
